import { render, staticRenderFns } from "./ConferenceListCard.vue?vue&type=template&id=1e4ef112&scoped=true"
import script from "./ConferenceListCard.vue?vue&type=script&lang=js"
export * from "./ConferenceListCard.vue?vue&type=script&lang=js"
import style0 from "./ConferenceListCard.vue?vue&type=style&index=0&id=1e4ef112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ef112",
  null
  
)

export default component.exports